"use client";

import type { FC } from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

export interface PlanMoveRowProps {
  number: number;
  title: string;
  tag: string;
  body: string;
  locked?: boolean;
}

export const PlanMoveRow: FC<PlanMoveRowProps> = ({
  number,
  title,
  tag,
  body,
  locked = false,
}) => (
  <div
    className="flex gap-3 rounded-xl bg-background_solid_neutral_primary px-3.5 py-3"
    data-testid={`plan-move-row-${number}`}
    data-plan-locked={locked ? "true" : undefined}
  >
    <div
      className={cn(
        "flex size-[34px] shrink-0 items-center justify-center rounded-[17px]",
        locked ? "bg-background_white_overlay20" : "bg-content_brand_primary",
      )}
    >
      {locked ? (
        <Icon
          name="lock-alt-fill"
          size={24}
          className="text-content_inverse_primary"
        />
      ) : (
        <span className="title_l text-content_inverse_primary">{number}</span>
      )}
    </div>
    <div className={cn("min-w-0 flex-1", locked && "blur-[2.5px]")}>
      <div className="flex items-center gap-2">
        <p className="title_l min-w-0 flex-1 break-words text-content_primary">
          {title}
        </p>
        {!!tag && (
          <span className="body_medium_s shrink-0 rounded bg-background_brand_overlay10 px-2 py-1 text-content_brand_primary">
            {tag}
          </span>
        )}
      </div>
      <p className="body_medium_s mt-2 break-words text-content_secondary">
        {body}
      </p>
    </div>
  </div>
);
